import { render, staticRenderFns } from "./EventTemplateStep.vue?vue&type=template&id=44a2b70b"
import script from "./EventTemplateStep.vue?vue&type=script&lang=js"
export * from "./EventTemplateStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports